import { CallbackEffects } from './callback.effects';

export const effects: any[] = [CallbackEffects];
